// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-area_root__3MHZB","menuWrapper":"menu-area_menuWrapper__s5Yut","item":"menu-area_item__f2lwI"};